<template>
    <v-content>
        <v-layout wrap row align-center>
            <v-flex lg3 md3 xs8 sm3 pt-3 class="mortgage-list__logo" v-if="type !== 'union' && type !=='titleUnion'">
                <v-flex class="layout align-center" v-if="type === 'life'">
                    <img class="logo" :src="data.lifeImage" alt="life"/>
                </v-flex>
                <p v-if="type === 'life'">Жизнь</p>
                <v-flex class="layout align-center" v-if="type === 'property'" >
                    <img class="logo" :src="data.apartmentImage" alt="property"/>
                </v-flex>
                <p v-if="type === 'property'">Недвижимость</p>
                <v-flex class="layout align-center" v-if="type === 'title'" >
                    <img class="logo" :src="data.apartmentImage" alt="propertyAndTitle"/>
                </v-flex>
                <p v-if="type === 'title'">Недвижимость + Титул</p>
<!--                <p v-else-if="type === 'title' && !data.title">Недвижимость</p>-->
            </v-flex>
            <v-flex lg3 md3 xs8 sm3 pt-3 class="mortgage-list__logo" v-else>
                <v-flex class="layout align-center image-box" v-if="data.apartmentName === data.lifeName">
                    <img class="logo" :src="data.lifeImage" alt="life"/>
                </v-flex>
                <v-flex v-else>
                    <v-layout wrap row>
                        <v-flex xs5>
                            <img :src="data.apartmentImage" alt="apartmentImage" />
                        </v-flex>
                        <v-flex xs2 class="mortgage-list__logo__plus">
                            <img class="plus-img" :src="'/img/mortgage/+.png'" alt="+" />
                        </v-flex>
                        <v-flex xs5>
                            <img :src="data.lifeImage" alt="lifeImage" />
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex v-if="data.apartmentName === data.lifeName && type === 'union'" class="mortgage-list__logo__text">
                    <p>Недвижимость + Жизнь</p>
                </v-flex>
                <v-flex v-if="data.apartmentName === data.lifeName && type === 'titleUnion'" class="mortgage-list__logo__text">
                    <p>Недвижимость + Жизнь + Титул</p>
                </v-flex>
                <v-flex v-if="data.apartmentName !== data.lifeName && type === 'union'" class="mortgage-list__logo__text">
                    <v-layout wrap row>
                        <v-flex xs6 md5 class="text-xs-center">Недвижимость</v-flex>
                        <v-flex md2 class="text-xs-center hidden-sm-and-down">+</v-flex>
                        <v-flex xs6 md5 class="text-xs-center">Жизнь</v-flex>
                    </v-layout>
                </v-flex>
            </v-flex>
            <v-flex lg6 md6 sm8 pt-3 offset-xs1 xs3 offset-sm0 class="mortgage-list__data">
                <v-layout row wrap>

                    <!--       TODO: от процента комиссии возможно, нужно будет отказаться, потому что могут быть разные проценты по разным компаниям         -->
                    <!--                <v-flex sm4 md3 class="mortgage-list__data__item hidden-xs-only">-->
                    <!--                    <label>Комиссия, %</label>-->
                    <!--                    <p v-if="type !== 'union'">{{data.commissionPercents}}</p>-->
                    <!--                    <p v-else>{{data.property.commissionPercents}}</p>-->
                    <!--                </v-flex>-->
                    <v-flex lg4 sm5 md5 class="mortgage-list__data__item hidden-xs-only" v-if="showCommission">
                        <a v-show="!commissionsHidden"
                           @click="toggleCommissions"
                           class="color-black tip-icon width-auto"
                           data-tippy-animateFill="false"
                           data-tippy-animation="scale"
                           data-tippy-content="Нажмите, чтобы скрыть вознаграждение"
                        >
                            <label>Вознаграждение, Р</label>
                            <p>
                                {{ data.premium > 0 ? Math.round(Number(data.commission)) : '-' }}
                            </p>
                        </a>
                    </v-flex>
                    <v-flex lg4 sm5 md5 class="mortgage-list__data__item hidden-xs-only" v-if="showCommission">
                        <a v-show="!commissionsHidden"
                           @click="toggleCommissions"
                           class="color-black tip-icon width-auto"
                           data-tippy-animateFill="false"
                           data-tippy-animation="scale"
                           data-tippy-content="Нажмите, чтобы скрыть вознаграждение"
                        >
                            <label>Вознаграждение, %</label>
                            <p>
                                {{ data.premium > 0 ? (Math.floor(data.commission / data.premium * 10000) / 100).toFixed(0) : '-' }}
                            </p>
                        </a>
                        <a v-show="commissionsHidden"
                           @click="toggleCommissions"
                           class="color-black"
                           style="align-self: flex-start;"
                        >
                            <v-flex>
                                Вернуть
                            </v-flex>
                        </a>
                    </v-flex>
                    <v-flex lg4 xs12 sm2 md2 class="mortgage-list__data__item price-item" v-if="type === 'title' || type === 'titleUnion'">
                        <label class="hidden-xs-only">Цена, Р</label>
                        <p class="price-text">{{ data.titleCost > 0 ? (parseFloat(data.titleCost) + parseFloat(data.premium)).toFixed(2) : '-' }} <span
                            class="hidden-sm-and-up">P</span></p>
                        <!--                    <div class="full-price"><s>{{data.premium}} <span class="hidden-sm-and-up">P</span></s></div>-->
                    </v-flex>
                    <v-flex lg4 xs12 sm2 md2 class="mortgage-list__data__item price-item" v-else>
                        <label class="hidden-xs-only">Цена, Р</label>
                        <p class="price-text">
                            {{ data.premium > 0 ? parseFloat(data.premium.toFixed(2)) : '-' }}
                            <span class="hidden-sm-and-up">P</span>
                        </p>
                        <!--                    <div class="full-price"><s>{{data.premium}} <span class="hidden-sm-and-up">P</span></s></div>-->
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <!--<v-flex md12 class="mortgage-list__data__more hidden-sm-and-down">
                        <div v-if="!data.showMore">
                            <a @click="showMore()">Подробнее о полисе</a>
                            <v-icon class="material-symbols-outlined toggleUpDown" :class='{ "rotate": showMore }'>
                                expand_more
                            </v-icon>
                        </div>
                        <div v-else>
                            <a @click="showLess()">Скрыть подробности</a>
                            <v-icon class="material-symbols-outlined">
                                expand_less
                            </v-icon>
                        </div>
                    </v-flex>-->
                    <v-flex md12 class="mortgage-list__data__more hidden-sm-and-down">
                        <div v-if="!data.showMore">
                            <a @click="showMore()">Подробнее о полисе</a>
                            <v-icon class="material-symbols-outlined arrow-up-down" :class='{ "rotate": showMore }'>
                                expand_less
                            </v-icon>
                        </div>
                        <div v-else>
                            <a @click="showLess()">Подробнее о полисе</a>
                            <v-icon class="material-symbols-outlined arrow-up-down">
                                expand_less
                            </v-icon>
                        </div>
                    </v-flex>

                </v-layout>
            </v-flex>
            <v-flex sm6 class="layout align-center mortgage-list__data__more hidden-md-and-up hidden-xs-only">
                <div v-if="!data.showMore">
                    <a @click="showMore()">Подробнее о полисе</a>
                    <v-icon class="material-symbols-outlined arrow-up-down" :class='{ "rotate": showMore }'>
                        expand_less
                    </v-icon>
                </div>
                <div v-else>
                    <a @click="showLess()">Подробнее о полисе</a>
                    <v-icon class="material-symbols-outlined arrow-up-down">
                        expand_less
                    </v-icon>
                </div>
            </v-flex>
            <v-flex v-if="formIsChanged" layout column align-center xs12 sm6 lg3 md3 pt-4>
                <v-btn class="button next-button block" disabled>
                    <strong>Проведите перерасчет</strong>
                </v-btn>
            </v-flex>
            <v-flex v-else-if="(data.apartment !== undefined && data.error && !data.title) ||
                          (data.life !== undefined && data.error && !data.title) ||
                          (data.error !== undefined && data.error && !data.title)"
                    xs12 sm3 lg3 md3 class="mortgage-list__declined-block"
            >
                <strong>Не подтверждено</strong>
                <img
                    style="cursor:pointer;"
                    class="tip-icon" src="/svg/q_red.svg" alt=""
                    data-tippy-animateFill="false"
                    data-tippy-animation="scale"
                    data-tippy-theme="red"
                    data-tippy-offset="400, 50"
                    data-tippy-allowHTML="false"
                    data-tippy-sticky="true"
                    data-tippy-trigger="click"
                    data-tippy-appendTo="parent"
                    :key="data.error"
                    :data-tippy-content="(type === 'title' || type === 'titleUnion') ? 'Страхование титула недоступно для данной компании' : data.error"
                />
            </v-flex>
<!--            <v-flex v-else-if="(type === 'title' && !data.title) || (type === 'titleUnion' && !data.title)"
                    xs12 sm3 lg3 md3 class="mortgage-list__declined-block"
            >
                <strong>Не подтверждено</strong>
                <img
                    class="tip-icon" src="/svg/q_red.svg" alt=""
                    data-tippy-animateFill="false"
                    data-tippy-animation="scale"
                    data-tippy-theme="red"
                    :key="data.companyId"
                    :data-tippy-content="'Страхование титула недоступно для данной компании'"
                />
            </v-flex>-->
            <v-flex v-else-if="(data.title !== undefined && data.titleErrorText && (type === 'title' || type === 'titleUnion'))"
                    xs12 sm3 lg3 md3 class="mortgage-list__declined-block"
            >
                <strong>Не подтверждено</strong>
                <img
                    class="tip-icon" src="/svg/q_red.svg" alt=""
                    data-tippy-animateFill="false"
                    data-tippy-animation="scale"
                    data-tippy-theme="red"
                    :key="data.companyId"
                    :data-tippy-content="data.titleErrorText ? data.titleErrorText : 'Страхование титула недоступно для данной компании'"
                />
            </v-flex>
            <v-flex v-else layout column align-center xs12 sm6 lg3 md3 class="mortgage-list__button-block">
                <a v-if="isResult && orderStatus !== 'success'"
                   class="policy underline above-button text-center"
                   @click="checkConditions(true)"
                >
                    Оплатить по ссылке
                </a>
                <v-btn
                    class="button next-button block"
                    v-if="isResult && orderStatus === 'success'"
                    :id="data.apartment ? data.apartment : data.life"
                >

                    <v-flex>
                        <v-content v-if="data.companyId === this.successProcessing.companyId">
                            Оформлен<span class="hidden-sm-only">&nbsp;за&nbsp;<span
                            v-html="parseFloat(this.successProcessing.premium.toFixed(2))"></span>&nbsp;Р</span>
                        </v-content>
                        <v-content v-else>
                            <span v-html="parseFloat(data.premium.toFixed(2))"></span>&nbsp;Р
                        </v-content>
                    </v-flex>
                </v-btn>
                <v-btn @click="checkConditions(false)"
                       :loading="data.calc"
                       class="button next-button block" v-else
                       :id="data.apartment ? data.apartment : data.life"
                >
                    <v-content v-if="data.calc" disabled="disabled">
                        Рассчитывается
                    </v-content>
                    <v-content v-else-if="isResult && (type === 'title' || type === 'titleUnion')">
                        Оформить<span class="hidden-sm-only">&nbsp;за&nbsp;<span
                        v-html="(parseFloat(data.premium) + parseFloat(data.titleCost)).toFixed(2)"></span>&nbsp;Р</span>
                    </v-content>
                    <v-content v-else-if="isResult">
                        Оформить<span class="hidden-sm-only">&nbsp;за&nbsp;<span
                        v-html="parseFloat(data.premium.toFixed(2))"></span>&nbsp;Р</span>
                    </v-content>
                    <v-content v-else>
                        Продолжить оформление
                    </v-content>
                </v-btn>
                <marquee behavior="scroll" direction="left"
                         style="display: block; padding: 10px 22px 0;"
                         v-if="policyStartDate && policyStartDateMarquee"
                         class="blink-green"
                         v-html="policyStartDate"
                ></marquee>
                <span style="display: block; padding: 10px 22px 0;"
                      v-else-if="policyStartDate"
                      class="blink-green"
                      v-html="policyStartDate"
                ></span>


            </v-flex>

            <v-flex lg3 md3>
            </v-flex>
            <v-flex xs12 class="layout align-center justify-center mortgage-list__data__more hidden-sm-and-up">
                <div v-if="!data.showMore">
                    <a @click="showMore()">Подробнее о полисе</a>
                    <v-icon class="material-symbols-outlined arrow-up-down" :class='{ "rotate": showMore }'>
                        expand_less
                    </v-icon>
                </div>
                <div v-else>
                    <a @click="showLess()">Подробнее о полисе</a>
                    <v-icon class="material-symbols-outlined arrow-up-down">
                        expand_less
                    </v-icon>
                </div>
            </v-flex>
            <v-flex lg9 md9 sm12 xs12 class="mortgage-list__data__info"
                    v-model="panel"
            >
                <mortgage-result-item-info
                    :parentKey="parentKey"
                    :data="data"
                    :type="type"
                    :panel="data.panel"
                    :duration="duration"
                    :isResult="isResult"
                    :moreInfo="moreInfo"
                    :unionInfoLife="unionInfoLife"
                    :unionInfoProperty="unionInfoProperty"
                ></mortgage-result-item-info>
            </v-flex>

        </v-layout>
        <v-layout wrap row>

        </v-layout>
        <hr/>
    </v-content>
</template>
<script>
import MortgageResultItemInfo from './MortgageResultItemInfo';
import MortgageConfirmModal from './MortgageConfirmModal';

export default {
    name: "MortgageResultItem",
    props: [
        'data',
        'type',
        'parentKey',
        'duration',
        'phone',
        'isResult',
        'wait',
        'showCommission',
        'moreInfoProperty',
        'moreInfoLife',
        'formIsChanged',
        'orderStatus',
        'successProcessing',
        'commissionsHidden',
    ],
    data: () => ({
        panel: false,
        tooltipShow: false,
        dialog: false,
        isLink: false,
        policyStartDate: null,
        policyStartDateMarquee: false,
        moreInfo: {},
        unionInfoLife: {},
        unionInfoProperty: {},
    }),
    components: {
        'mortgage-result-item-info': MortgageResultItemInfo,
        'mortgage-confirm-modal': MortgageConfirmModal
    },
    created() {
        // конкретно для ВТБ и ПАРИ
        /*
        if (this.data.apartment === 'pari_mortgage' || this.data.life === 'pari_mortgage') {
            this.data.premium = 0;
        }*/

        if (this.data.apartmentStartPolicyDate && this.data.lifeStartPolicyDate) {
            if (this.data.apartmentStartPolicyDate === this.data.lifeStartPolicyDate) {
                let date = new Date(Date.parse(this.data.apartmentStartPolicyDate))
                this.policyStartDate = `Начало действия - ${date.toLocaleDateString('ru')}`
            } else {
                let apartmentDate = new Date(Date.parse(this.data.apartmentStartPolicyDate))
                let lifeDate = new Date(Date.parse(this.data.lifeStartPolicyDate))
                this.policyStartDate = `Начало действия: Имущество - ${apartmentDate.toLocaleDateString('ru')}, Жизнь - ${lifeDate.toLocaleDateString('ru')}`
                this.policyStartDateMarquee = true
            }
        } else if (this.data.apartmentStartPolicyDate) {
            let date = new Date(Date.parse(this.data.apartmentStartPolicyDate))
            this.policyStartDate = `Начало действия - ${date.toLocaleDateString('ru')}`
        } else if (this.data.lifeStartPolicyDate) {
            let date = new Date(Date.parse(this.data.lifeStartPolicyDate))
            this.policyStartDate = `Начало действия - ${date.toLocaleDateString('ru')}`
        }

        if (this.data.type === 'apartment') {
            this.moreInfo = {};
            this.moreInfoProperty.forEach((obj) => {
                if (this.data.apartmentName === obj.name) {
                    this.moreInfo = obj;
                }
            })
        }

        if (this.data.type === 'life') {
            this.moreInfo = {};
            this.moreInfoLife.forEach((obj) => {
                if (this.data.lifeName === obj.name) {
                    this.moreInfo = obj;
                }
            })
        }

        if (this.data.type === 'lifeAndApartment') {
            this.unionInfoLife = {};
            this.unionInfoProperty = {};
            this.moreInfoLife.forEach((obj) => {
                if (this.data.lifeName === obj.name && this.data.apartmentName === obj.name) {
                    this.unionInfoLife = obj;
                }
            })
            this.moreInfoProperty.forEach((obj) => {
                if (this.data.lifeName === obj.name && this.data.apartmentName === obj.name) {
                    this.unionInfoProperty = obj;
                }
            })
        }
    },
    methods: {
        showMore() {
            this.data.showMore = true
            this.data.panel = ['0']
            this.panel = true
        },
        showLess() {
            this.data.showMore = false
            this.data.panel = []
            this.panel = false
        },
        nextStep() {
            this.$emit('nextStep')
        },
        checkConditions(link = false) {
            if (this.isResult) {
                this.isLink = link
                let confirmModalItems = {
                    data: this.data,
                    phone: this.phone,
                    wait: this.wait,
                    isLink: this.isLink,
                }
                this.$nextTick(() => {
                    this.$emit('showConfirmModal', confirmModalItems)
                })
                return
            }
            this.issue()
        },
        issue() {
            this.nextStep();
            this.$nextTick(() => {
                this.data.isLink = this.isLink
                this.$emit('issue', this.data)
            })
        },
        toggleCommissions() {
            this.$emit('toggleComissions')
        }
    }
}
</script>
<style scoped>
.blink-green {
    -moz-animation: blink-green 2s linear infinite;
    -webkit-animation: blink-green 2s linear infinite;
    animation: blink-green 2s linear infinite;
}

.btn-loading {
    width: 25px;
    position: relative;
    top: 5px;
    right: -15px;
}

.color-black {
    color: #000000;
}

@-moz-keyframes blink-green {
    0% {
        color: #00ba57;
    }
    100% {
        color: black;
    }
}

@-webkit-keyframes blink-green {
    0% {
        color: #00ba57;
    }
    100% {
        color: black;
    }
}

@keyframes blink-green {
    0% {
        color: #00ba57;
    }
    100% {
        color: black;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/mortgage/MortgageResultItem.vue